<div v-if="isLoggedIn && showToolbar" class="tt-c-user-toolbar tt-u-spacing--left--sm">
  <div v-if="isLoggedIn" class="tt-c-user-toolbar__name">{{ formattedUsername }}</div>
  <tt-menu v-if="isLoggedIn && menuItems" :tiggerAriaLabel="$msg('userToolbar.optionsMenuLabel')" triggerClass="tt-c-user-toolbar__menu-trigger" triggerType="icon">
    <template v-slot:triggerContent><tt-icon name="more-h" size="sm"></tt-icon></template>
    <tt-menu-list class="tt-c-user-toolbar__menu-list" :menuItems="menuItems" @menuItemSelected="menuItemSelected"></tt-menu-list>
  </tt-menu>
</div>
